<mat-card class="link-card {{ content.href ? '' : 'no-link' }}" routerLink="{{ content.href }}">
  <mat-card-title>{{ content.title }}</mat-card-title>
  <mat-card-content *ngIf="content.text">{{ content.text }}</mat-card-content>
</mat-card>
